import React, { useEffect, useState } from "react";
import WordByWord from "./About Us/WordByWord";
import { getServices } from "../Services/AuthService";

function Service() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadServices = async () => {
      try {
        const response = await getServices();
        const data = response.data;

        setCategories(data);
        setSelectedCategory(data[0] ?? null);
      } catch (error) {
        console.error("Failed to load services", error);
      } finally {
        setLoading(false);
      }
    };

    loadServices();
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-lg text-gray-500 animate-pulse">
        Loading services...
      </div>
    );
  }

  return (
    <div className="min-h-[600px] bg-gradient-to-br from-neutral-50 via-neutral-100 to-neutral-50 px-4  pb-10 md:pb-20 sm:px-6 lg:pt-12">
      <div className="mx-auto max-w-[1400px]">
        <div className="lg:hidden sticky top-0 z-20 bg-neutral-50 py-3 mb-4">
          <div className="flex gap-2 overflow-x-auto no-scrollbar">
            {categories.map((category) => {
              const active =
                selectedCategory?.categoryId === category.categoryId;

              return (
                <button
                  key={category.categoryId}
                  onClick={() => setSelectedCategory(category)}
                  className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-all ${
                    active
                      ? "bg-accent-gold text-primary-dark shadow"
                      : "bg-neutral-light text-neutral-textPrimary"
                  }`}
                >
                  {category.categoryName}
                </button>
              );
            })}
          </div>
        </div>
        <div className="grid gap-6 lg:grid-cols-[280px_minmax(0,1fr)] lg:gap-10 xl:gap-12">
          <aside className=" hidden lg:block h-fit rounded-2xl border border-neutral-border bg-neutral-white p-5 shadow-md lg:sticky lg:top-24 lg:p-6">
            <h3 className="mb-6 text-2xl font-bold text-neutral-textPrimary">
              Categories
            </h3>

            <ul className="grid gap-2 sm:grid-cols-2 lg:grid-cols-1">
              {categories.map((category) => {
                const active =
                  selectedCategory?.categoryId === category.categoryId;

                return (
                  <li
                    key={category.categoryId}
                    onClick={() => setSelectedCategory(category)}
                    className={`relative cursor-pointer rounded-lg px-4 py-3 transition-all duration-300 ${
                      active
                        ? "bg-primary-dark text-neutral-white shadow-md"
                        : "bg-neutral-light text-neutral-textPrimary hover:bg-accent-goldLight"
                    }`}
                  >
                    {active && (
                      <span className="absolute left-0 top-0 h-full w-1 rounded-l-lg bg-accent-gold" />
                    )}
                    {category.categoryName}
                  </li>
                );
              })}
            </ul>
          </aside>

          <main className="flex min-h-[420px] flex-col rounded-2xl border border-neutral-border bg-white shadow-md">
            <h2 className="sticky top-[60px] lg:top-0 z-10 bg-white px-4 py-3 text-lg font-bold text-neutral-textPrimary sm:px-6 lg:px-10 lg:text-2xl">
              {selectedCategory?.categoryName}
            </h2>

            <div className="custom-scrollbar flex-1 overflow-y-auto px-4 py-4 sm:px-6 lg:px-10 lg:py-6">
              <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3">
                {selectedCategory?.services.map((service, index) => (
                  <div
                    key={service.id}
                    style={{ animationDelay: `${index * 80}ms` }}
                    className="group cursor-pointer rounded-xl border border-neutral-border bg-neutral-light p-4 transition-all duration-300 hover:-translate-y-2 hover:bg-primary-dark hover:text-accent-gold hover:shadow-lg animate-[cardFade_0.4s_ease-out]"
                  >
                    <h4 className="mb-1 text-lg font-bold">
                      {service.serviceName}
                    </h4>

                    <span className="text-sm text-neutral-textSecondary group-hover:text-neutral-white/80">
                      <WordByWord
                        text={service.description}
                        speed={50}
                        pause={2000}
                      />
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </main>
        </div>
      </div>

      <style>
        {`
          @keyframes cardFade {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* Hide scrollbar */
          .no-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .no-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}
      </style>
    </div>
  );
}

export default Service;
